module.exports = __webpack_public_path__ + "static/phone-in-hand-28b97b9a73210af3c6b5db2ef0eddb58.png";